//export const GEOSERVER_URL = 'http://localhost:8080/geoserver/geolinq/ows';
//export const API_URL = 'http://localhost:8081'; // or your backend base URL
//export const GEOSERVER_URL = 'https://geo.sevenn.be/geolinq/ows';
// GIS API goes through the same-origin Pages Function proxy (auth injected server-side).
export const API_URL = '/api/';
// Geoserver is called directly from the browser (CORS: access-control-allow-origin: *,
// no auth needed for these public reference layers) — same pattern as upstream.
export const GEOSERVER_URL = 'https://geo.sevenn.be/geolinq/ows';
//export const API_URL = '/api/';
//export const ADDRESS_LAYER = 'geolinq:u101093ViewVboDienstversieType'; // or your backend base URL
export const countryConfig = {
  NL: {
    layer: 'geolinq:u101093ViewVboDienstversieType',
    columns: {
      postcode: 'u104723postcode6_BAG', //'u107260postcode',
      houseNumber: 'u107260huisnummer',
      street: 'u107260straatnaam'
    }
  },
  BE: {
    layer: 'geolinq:u101234BE_Adres',
    columns: {
      postcode: 'postcode',
      houseNumber: 'housenumber',
      street: 'streetname'
    }
  }
};
